import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Auth, getRedirectResult, signInWithRedirect } from '@angular/fire/auth';
import { DeviceService } from 'src/app/core/device.service';
import { GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { AuthService } from 'src/app/core/auth.service';
// import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: false
})
export class RegisterComponent {

  form!: FormGroup;

  loading: boolean = false;
  processSuccessful: boolean = false;
  alertType: undefined | 'success' | 'error';
  alertMessage: string = '';

  submittedEmail: string = '';

  referrer: string = '';
  attribution: any = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService,
    private deviceService: DeviceService,
    private route: ActivatedRoute,
    private auth: Auth,
    // private socialAuthService: SocialAuthService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.referrer = params['referrer'];

      this.attribution = {
        utm_source: params['utm_source'],
        utm_medium: params['utm_medium'],
        utm_campaign: params['utm_campaign'],
        utm_content: params['utm_content'],
        gclid: params['gclid']
      };
    });

    /*this.auth.onAuthStateChanged((user) => {
      if (user) {
        console.log('User is signed in:', user);
      } else {
        console.log('User is not signed in');
      }
    });

    getRedirectResult(this.auth)
    .then(async (result) => {
      if (result?.user) {
        const token = await result.user.getIdToken();
        this.authService.socialRegister(token, this.deviceService.getDeviceSize(), this.getOS(), this.referrer).subscribe(
          (response) => {
            if (!response.user.onboardingDone) {
              this.router.navigate(['onboarding']);
            } else {
              this.router.navigate(['/']);
            }
          },
          (error) => {
            console.error("Error during registration:", error);
          }
        );
      } else {
        console.log('No user sign-in result');
      }
    })
    .catch((error) => {
      console.error('Error handling redirect result:', error);
    });*/

    this.form = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/[!@#$%^&*(),.?":{}|<>]/)]]
    });
  }

  socialRegister(authService: string) {
    let provider;
    if (authService === 'google') {
      provider = new GoogleAuthProvider();
    } else if (authService === 'apple') {
      provider = new OAuthProvider('apple.com');
    } else {
      provider = new OAuthProvider('microsoft.com');
    }

    signInWithRedirect(this.auth, provider);
    // return this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  submit() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    const language = this.translate.getBrowserLang();
    this.submittedEmail = this.form.value.email;
    this.authService.register(this.form.value.name, this.form.value.email, this.form.value.password, language ? language : 'en', this.deviceService.getDeviceSize(), this.getOS(), this.referrer, this.attribution?.utm_source, this.attribution?.utm_campaign).subscribe(
      (result: any) => {
        this.alertType = 'success';
        this.alertMessage = 'Your account was successfully created. Please click the link in the mail that we just sent you. After confirming your email, you can login and start using Sparkly.'
        this.loading = false;
        this.processSuccessful = true;
        this.form.reset();
        this.trackConversion();
      },
      (error) => {
        this.alertType = 'error';
        this.alertMessage = error.error.message;
        this.loading = false;
      }
    );
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  getOS(): string {
    const userAgent = window.navigator.userAgent;

    if (/Windows NT/.test(userAgent)) {
      return 'windows';
    } else if (/Macintosh/.test(userAgent)) {
      return 'macOS';
    } else if (/Linux/.test(userAgent)) {
      return 'linux';
    } else if (/Android/.test(userAgent)) {
      return 'android';
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      return 'iOS';
    } else {
      return 'unknown';
    }
  }

  trackConversion() {
    (window as any).gtag('event', 'conversion', {
      'send_to': 'AW-10895089274/gQN2CKzd_qIaEPq8l8so',
      'value': 1.0,
      'currency': 'EUR'
    });
  }
}
